/**
 * @fileoverview Indirect Costs route wrapper that renders the Kanban costs hub.
 * @module features/indirect-costs/pages/IndirectCostsPage
 */

import type { ReactElement } from 'react'
import { CostsKanbanPage } from '@/features/costs-hub'

/**
 * IndirectCostsPage
 * Entry point for the costs kanban view defaulted to Costs column.
 */
export default function IndirectCostsPage(): ReactElement {
  return <CostsKanbanPage initialPosition={0} />
}
